/* eslint-disable react/prop-types */
import React from 'react';
import { InputGroup as OriginalInputGroup } from '@fiverr-private/forms';
import { useParentPropsOverrideContext } from '@fiverr-private/ui_utils';

const InputGroup = ({ children, ...props }) => {
    const context = useParentPropsOverrideContext();

    return (
        <OriginalInputGroup {...props} {...context}>
            {children}
        </OriginalInputGroup>
    );
};

export default InputGroup;
